import Swiper from "swiper/swiper-bundle";

const CategoryDefinitionUid = 'b2f419dd-da7e-4158-8d0a-d91f6b4635b5';

const params = new URLSearchParams(document.location.search);
const companyTokenParam = params.get("company_token");
const companyToken = companyTokenParam ? companyTokenParam : "31KrznkCAdePvmYRuubnhTLYP5I0uACzUrk70qx41GrRhpTnKw";
export const companyTokenForCodeSnippet = companyTokenParam ? companyTokenParam : "<place your Access Token here>";

const apiUrl = "https://eu.admin.zolak.tech/api";

let categodyDefinitionId;

const customerIdParam = params.get("cid");

const setCustomerId = () => {
  if(customerIdParam) {
    window.localStorage.setItem("zolak_customer_id", customerIdParam);
    window.dispatchEvent(new Event("storage"));
  } 
};
setCustomerId();

getProducts();

function getProducts() {
  const get = async () => {
    return fetch(`${apiUrl}/products`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Company-Token": companyToken,
        "Cache-Control": "no-cache, no-store, must-revalidate",
        "Pragma": "no-cache",
      },
    });
  };

  const getAttributeDefinition = async () => {
    return fetch(`${apiUrl}/attribute-definitions?uid=${CategoryDefinitionUid}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Company-Token": companyToken,
        "Cache-Control": "no-cache, no-store, must-revalidate",
        "Pragma": "no-cache",
      },
    })
  }

  getAttributeDefinition()
    .then(async (data) => {
      const categoryDefinition = (await data.json()).items.pop();
      categodyDefinitionId = categoryDefinition.id;

      get()
        .then(async (data) => {
          const responseData = await data.json();
          const products = responseData.items
            .filter((product) =>
              product.attributes.some((productAttr) => productAttr.definition == categodyDefinitionId)
            )
          //.sort((a, b) => (Number(a.defaultContent) === Number(b.defaultContent)) ? 0 : Number(a.defaultContent) ? 1 : -1);

          if (products.length > 0) {
            const swiper = new Swiper(".swiper-container", {
              slidesPerView: 2,
              spaceBetween: 15,
              loop: false,
              a11y: true,
              updateOnWindowResize: true,
              mousewheel: true,
              pagination: {
                clickable: "true",
                el: ".swiper-pagination",
                type: "progressbar",
              },
              freeMode: true,
              allowTouchMove: true,
              clickable: true,
              on: {
                click: (swiper) => {
                  const index = swiper.clickedIndex;
                  swiper.slideTo(index);
                  setCurrentProduct(products[index]);
                }
              },
              breakpoints: {
                450: {
                  slidesPerView: 3,
                  spaceBetween: 32,
                },
                700: {
                  slidesPerView: 4,
                  spaceBetween: 32,
                },
              },
            });

            const slides = products.map((product) => {
              return `
              <div class="swiper-slide try_products">
                <div class="card_try_wrapper">
                  <img class="card_try_image" type="image/png" id="swiper-slide-image" src="${product.thumbnail !== undefined ? product.thumbnail : '/wp-content/themes/zolak/src/img/no-image2.png'}">
                </div>
                <div class="card_try_heading">${product.name.length > 12 ? product.name.slice(0, 12) + "..." : product.name}</div>
              </div>
            `;
            });
            swiper.appendSlide(slides);

            setCurrentProduct(products[0]);
          } else {
            console.error("No products found");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    })
    .catch((e) => {
      console.error(e);
    });
}

const setCurrentProduct = (selectedProduct) => {
  window.localStorage.setItem("selectedProductID", selectedProduct.externalId);
  window.dispatchEvent(new Event("storage"));

  const DEFAULT_DESCRIPTION =
    "This product is designed for ultimate comfort, with plush cushions and for lounging. The soft, cloud-like fabric adds a cozy and inviting feel to any living room. This product is perfect for relaxing and unwinding after a long day.";
  const DEFAULT_CATEGORY = "#Product Category";

  const NO_IMAGE = "/wp-content/themes/zolak/src/img/no-image2.png";

  const productDescription = selectedProduct.description;
  const productPrice = selectedProduct.price;
  const productCurrency = selectedProduct.currency;
  const description = productDescription
    ? productDescription
    : DEFAULT_DESCRIPTION;

  const categoryAttribute = selectedProduct.attributes.find(
    (attr) => attr.definition == categodyDefinitionId
  );
  const productCategory = categoryAttribute.value;
  const category = productCategory ? "#" + productCategory : DEFAULT_CATEGORY;

  const interiorButton = document.getElementById("start-with-product");
  interiorButton.setAttribute("data-id", selectedProduct.externalId);

  const configuratorButton = document.getElementById("start-with-configurator");
  configuratorButton.setAttribute("data-id", selectedProduct.externalId);

  let cardPrice = document.getElementById("product-price");
  cardPrice.innerText = productPrice && productCurrency ? productPrice + " " + productCurrency : "289 EUR";

  const cardName = document.getElementById("product-name");
  cardName.innerText = selectedProduct.name;

  const breadcrumbName = document.getElementById("breadcrumb-name");
  breadcrumbName.innerText = selectedProduct.name;

  const breadcrumbCategory = document.getElementById("breadcrumb-category");
  breadcrumbCategory.innerText = category;

  const cardCategory = document.getElementById("product-category");
  cardCategory.innerText = category;

  const cardDescription = document.getElementById("product-description");
  cardDescription.innerText = description;
  let cardImageSrc = document.getElementById("product-image");
  cardImageSrc.onload = function () {
    const overlay = document.querySelector(".card_info__image");
    overlay.classList.toggle("preloader");
  };
  cardImageSrc.src = selectedProduct.thumbnail !== undefined ? selectedProduct.thumbnail : NO_IMAGE;
  cardImageSrc.className = selectedProduct.thumbnail !== undefined ? " " : "no-image";
  cardImageSrc.type = "image/png";
};

const pageId = document.getElementById('page');

const getCloseAppEvent = ({ onCloseIconClick }) =>
  new CustomEvent("zolak:update:close", {
    bubbles: true, // bubble event to containing elements
    composed: true, // let the event pass through the shadowDOM boundary
    detail: {
      onCloseIconClick,
    },
  });

const closeHandler = (zolakViewerPredifened) => {
  const handleCloseAppIconClick = () => {
    window.stopZolak();
    pageId.classList.remove('hidden');
  };

  zolakViewerPredifened.dispatchEvent(
    getCloseAppEvent({
      onCloseIconClick: handleCloseAppIconClick,
    })
  );
};

const closeHandlerProduct = (zolakViewer) => {
  const handleCloseAppIconClick = () => {
    window.stopZolak();
    pageId.classList.remove('hidden');
    document.getElementById('product-card-implementation').scrollIntoView();
  };

  zolakViewer.dispatchEvent(
    getCloseAppEvent({
      onCloseIconClick: handleCloseAppIconClick,
    })
  );
};

const closeHandlerConfigurator = (zolakAppProduct) => {
  const handleCloseAppIconClick = () => {
    window.stopZolakProduct();
    pageId.classList.remove('hidden');
    document.getElementById('product-card-implementation').scrollIntoView();
  };

  zolakAppProduct.dispatchEvent(
    getCloseAppEvent({
      onCloseIconClick: handleCloseAppIconClick,
    })
  );
};

const handleZolakViewerController = () => {
  const layersEvent = new CustomEvent("zolak:update:data", {
    bubbles: true, // bubble event to containing elements
    composed: true, // let the event pass through the shadowDOM boundary
    detail: {
      productId: productButton.dataset.id.toString(),
    },
  });
  const langSelector = document.getElementById("language-selector");
  const options = {
    view: 'product',
    language: langSelector.value,
    };
  window.startZolak(companyToken, options).then((zolakViewer) => {
    zolakViewer.element.dispatchEvent(layersEvent);

    closeHandlerProduct(zolakViewer.element);
  });
};

const handleZolakViewerPredefined = () => {
  const layersEvent = new CustomEvent("zolak:update:data", {
    bubbles: true, // bubble event to containing elements 
    composed: true, // let the event pass through the shadowDOM boundary 
    detail: {
      productId: false
    },

  });

  const langSelector = document.getElementById("language-selector");
  const options = {
    language: langSelector.value,
    };
  window.startZolak(companyToken, options).then((zolakViewer) => {
    zolakViewer.element.dispatchEvent(layersEvent);

    closeHandler(zolakViewer.element);
  });
};

const handleZolakViewerConfigurator = () => {
  const layersEvent = new CustomEvent("zolak:update:data", {
    bubbles: true, // bubble event to containing elements
    composed: true, // let the event pass through the shadowDOM boundary
    detail: {
      productId: productButton.dataset.id.toString(),
    },
  });
  const langSelector = document.getElementById("language-selector");
  const options = {
    language: langSelector.value,
    };
  window.startZolakProduct(companyToken, options).then((zolakAppProduct) => {
    zolakAppProduct.element.dispatchEvent(layersEvent);

    closeHandlerConfigurator(zolakAppProduct.element);
  });
};


const productButton = document.getElementById("start-with-product");
productButton.onclick = () => {
  handleZolakViewerController();
};

const configuratorButton = document.getElementById("start-with-configurator");
configuratorButton.onclick = () => {
  handleZolakViewerConfigurator();
};

const predefinedInteriorsButton = document.getElementById("predefined-interiors");
predefinedInteriorsButton.onclick = () => {
  handleZolakViewerPredefined();
};

const executeComponentScriptViaUrl = params.get('showroom');

if (executeComponentScriptViaUrl === '') {
  pageId.classList.add('hidden');
  predefinedInteriorsButton.click();
}

export default handleZolakViewerController;
